var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Partner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 32.1829V29.1829C25.5 27.5916 24.8679 26.0654 23.7426 24.9402C22.6174 23.815 21.0913 23.1829 19.5 23.1829H7.5C5.9087 23.1829 4.38258 23.815 3.25736 24.9402C2.13214 26.0654 1.5 27.5916 1.5 29.1829V32.1829",
    stroke: "#E07400 ",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.1829C16.8137 17.1829 19.5 14.4966 19.5 11.1829C19.5 7.86915 16.8137 5.18286 13.5 5.18286C10.1863 5.18286 7.5 7.86915 7.5 11.1829C7.5 14.4966 10.1863 17.1829 13.5 17.1829Z",
    stroke: "#E07400 ",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 32.1829V29.1829C34.499 27.8535 34.0565 26.5621 33.242 25.5114C32.4276 24.4607 31.2872 23.7103 30 23.3779",
    stroke: "#E07400 ",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 5.37793C25.2906 5.70838 26.4346 6.45898 27.2515 7.5114C28.0684 8.56381 28.5118 9.85817 28.5118 11.1904C28.5118 12.5227 28.0684 13.817 27.2515 14.8695C26.4346 15.9219 25.2906 16.6725 24 17.0029",
    stroke: "#E07400 ",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner);
export default __webpack_public_path__ + "static/media/partner.b351e99ca80016a232af4ed104cdf41a.svg";
export { ForwardRef as ReactComponent };